/* ═══════════════════════════════════════════════════════════════════════════
   BẢN SAO CHIẾN DỊCH — trang đọc dành cho 107 khách đã làm quiz mà chưa mua.

   GỐC LÀ `assets/pheu-luan-giai.js`. File này là bản chép ngày 16/09/2026, KHÔNG phải
   bản cải tiến. Sửa lỗi cách vẽ bài đọc thì sửa ở GỐC trước, rồi chép sang đây — đừng
   sửa mỗi bên này rồi tưởng đã xong.

   VÌ SAO CHÉP HẲN RA thay vì dùng chung: trang gốc là chỗ khách ĐÃ TRẢ TIỀN vào đọc.
   Chiến dịch này sống vài tuần rồi chết, mà mỗi lần sửa cho 107 người dùng chung file
   là một lần đặt cược vào trang của người đã trả tiền. Bản sao ngắn hạn rẻ hơn.

   🗓️ XOÁ FILE NÀY khi chiến dịch 107 đóng — cùng với `page.pheu-107-*`,
      `sections/pheu-107-*` và `assets/pheu-107-*`.

   KHÁC GỐC ĐÚNG MỘT CHỖ: biểu thức bắt mã phiên ở `layMa()` — xem chú thích tại đó.
   ═══════════════════════════════════════════════════════════════════════════ */

/* Trang luận giải — lấy bản đọc từ API rồi vẽ.
 *
 * Mã phiên đi qua MẢNH NEO `#s=<uuid>`, không qua tham số. Mảnh neo không được gửi lên
 * máy chủ, không lọt nhật ký truy cập, không lọt Referer. Mã phiên là chìa khoá đọc bản
 * riêng của từng người nên phải ở chỗ ít dấu vết nhất.
 *
 * Không tự đoán quyền: máy chủ trả `access` là gì thì vẽ theo đúng thế. Chưa trả tiền thì
 * API trả bản rút gọn, việc chặn nằm ở đó chứ không nằm ở đây — chặn bằng JS thì mở
 * DevTools là qua.
 */
(function () {
  var goc = document.querySelector('[data-plg]');
  if (!goc) return;

  var API = (goc.getAttribute('data-goc') || '').replace(/\/+$/, '');
  var oTai = goc.querySelector('[data-plg-dang-tai]');
  var oThieu = goc.querySelector('[data-plg-thieu-ma]');
  var oLoi = goc.querySelector('[data-plg-loi]');
  var oND = goc.querySelector('[data-plg-noi-dung]');
  var nutThuLai = goc.querySelector('[data-plg-thu-lai]');

  function hien(el) {
    [oTai, oThieu, oLoi, oND].forEach(function (e) {
      if (e) e.hidden = (e !== el);
    });
  }

  /* Chỉ nhận dạng uuid. Mã lạ thì đừng ghép vào địa chỉ rồi gọi đi — đó là chữ người lạ
     đưa vào qua thanh địa chỉ. */
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  function layMa() {
    /* Bộ nhớ phiên trước: đầu <head> của `layout/theme.liquid` đã cất mã từ mảnh neo vào đó
       rồi xoá mảnh neo để pixel không đọc được. Mảnh neo chỉ còn khi trình duyệt chặn lưu trữ. */
    var ma = '';
    try { ma = (sessionStorage.getItem('ms_phien') || '').trim(); } catch (e) { ma = ''; }
    if (ma) return UUID.test(ma) ? ma : '';
    var h = window.location.hash || '';
    /* ⚠️ `[^&#?]` chứ KHÔNG phải `[^&]` — khác gốc đúng chỗ này.
       Klaviyo chèn tham số theo dõi click (`_kx=…`) vào địa chỉ trong thư, và không tài
       liệu nào của họ cam kết chèn TRƯỚC hay SAU dấu `#`. Chèn sau thì địa chỉ thành
       `…#s=<uuid>?_kx=abc`: lớp `[^&]+` nuốt trọn cả đuôi, `UUID.test()` trượt, và cả 107
       người cùng thấy màn "thiếu mã" — không lỗi nào báo, không log nào kêu.
       Với link sạch (`#s=<uuid>` trần) hai biểu thức cho kết quả y hệt nhau, nên đây là
       siết chặt chứ không đổi hành vi. */
    var m = h.match(/[#&]s=([^&#?]+)/);
    ma = m ? decodeURIComponent(m[1]).trim() : '';
    return UUID.test(ma) ? ma : '';
  }

  /* Token QA preview: địa chỉ có ?preview=<token> thì chuyền xuống API để nó mở bậc cao
     nhất mà không cần đơn hàng thật. Chỉ dùng khi tự tay mở link kiểm tra — token là secret
     nội bộ (TEST_HARNESS_TOKEN bind ở Cloudflare), không phát cho khách. Thiếu thì gọi như
     thường. Máy chủ fail-closed: token sai hoặc chưa cấu hình đều rơi về bản free. */
  function duongDanKQ(ma) {
    var url = API + '/api/quiz/result/' + encodeURIComponent(ma);
    var m = (window.location.search || '').match(/[?&]preview=([^&]+)/);
    if (m && m[1]) url += '?preview=' + encodeURIComponent(decodeURIComponent(m[1]));
    return url;
  }

  /* ── Địa chỉ thư — cách nhận diện CỦA CHIẾN DỊCH ─────────────────────────────
     Luồng live nhận diện bằng mã phiên trên mảnh neo. Chiến dịch 107 nhận diện bằng ĐỊA CHỈ
     THƯ, vì thư gửi đi không mang được mã phiên của từng người mà vẫn phải một cú bấm.
     Địa chỉ cũng đi qua mảnh neo (`#email=`), KHÔNG qua tham số: tài liệu API cấm đặt địa
     chỉ vào URL mà máy chủ hay pixel đọc được, mà query string thì cả hai đều đọc được.

     Giữ cả hai đường: có địa chỉ thì dùng `result-by-email`, không có mà có mã phiên thì
     dùng đường cũ. Nhờ vậy một link kiểu cũ vẫn mở được, không phải bỏ đi. */
  function layEmail() {
    var e = '';
    try { e = (sessionStorage.getItem('ms107_email') || '').trim(); } catch (x) {}
    if (!e) {
      try {
        var m = (window.location.hash || '').match(/[#&]email=([^&#?]+)/);
        if (m) e = decodeURIComponent(m[1]).trim().toLowerCase();
      } catch (x) {}
    }
    if (!e) { try { e = (localStorage.getItem('ms107_email') || '').trim(); } catch (x) {} }
    return /^[^@\s]+@[^@\s.]+\.[^@\s]+$/.test(e) ? e : '';
  }

  function layKhoa() {
    var em = layEmail();
    if (em) return { kieu: 'email', gt: em };
    var ma = layMa();
    if (ma) return { kieu: 'phien', gt: ma };
    return null;
  }

  /* `application/json` ở đây chứ không phải `text/plain` như cổng tracking: tài liệu chỉ cam
     kết bỏ qua `content-type` cho `/api/quiz/track`, không nói gì về endpoint này. Chịu thêm
     một lượt preflight còn hơn đoán — origin đã nằm trong allowlist nên preflight qua được.

     Giới hạn riêng của endpoint này là 6 lần/phút/IP, chặt hơn đường cũ, vì địa chỉ thư thì
     đoán được còn mã phiên 128 bit thì không. Đừng gọi lại trong vòng lặp. */
  function goiKetQua(k) {
    if (k.kieu === 'email') {
      return fetch(API + '/api/quiz/result-by-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({ email: k.gt })
      });
    }
    return fetch(duongDanKQ(k.gt), { headers: { Accept: 'application/json' }, credentials: 'omit' });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     PHẦN VẼ — đã điền 31/08/2026, khi API v1.1 trả `chart` / `identity` / `score` / `copy`.

     Hình dạng bên dưới ĐO TRỰC TIẾP trên phiên thật, không chép từ tài liệu: bản
     `openapi.yaml` phục vụ ở `api.minespirit.com` vẫn là bản 29/08 chưa có `QuizChart`,
     còn repo `alomixtopas/mine_chapter` là kho riêng, không đọc được. Chỗ nào tài liệu và
     dữ liệu thật vênh nhau thì tin dữ liệu thật — bẫy cụ thể ghi ngay tại chỗ dùng.
     ───────────────────────────────────────────────────────────────────────── */
  /* Hình dạng lấy từ openapi.yaml (đo 29/08):
       ScoreResult { access, map[], report7[], meta }
       RenderedBlock { id, document: map|report7, section, ord, kind, text?, min_tier? }
       kind ∈ text · stone · door_open · door_locked · teaser · cta · build_variant

     Máy chủ quyết chỗ nào mở chỗ nào khoá. Ở đây chỉ vẽ đúng thứ nhận được: khối khoá thì
     dựng ổ khoá, không cố đoán bên trong có gì. Chưa trả tiền thì `text` rỗng hoặc là mồi. */
  /* ─────────────────────────────────────────────────────────────────────────
     VẼ BÀI ĐỌC — theo hợp đồng 2.1 (`api.minespirit.com/docs/api/quiz.md`).

     Bảy điều bắt buộc trong tài liệu đều là loại lỗi KHÔNG BÁO GÌ: trang vẫn dựng, chỉ là
     dựng sai. Ghi lại ngay đây để lần sau sửa không phá:

     1 · KHÔNG sắp lại mảng, KHÔNG coi `ord` là chỉ số. Mảng đã đúng thứ tự đọc. `ord` chỉ
         duy nhất trong (document, section), khởi lại ở mỗi section — 1 ở phần lớn, 0 ở
         `s1` `s2` `s3` — và CÓ LỖ (một section có thể về 1, 3, 4, 10). Sắp theo `section`
         cũng hỏng: nó thả `lock` vào giữa `AXIS_NAMES` và `s1`, tức bảng chặn nhảy lên
         trước bài đọc.
     2 · Tiêu đề CHỈ lấy từ khối `section_head`. Không in tên section — `s1` là khoá, không
         phải nhan đề. Section không có `section_head` thì không có tiêu đề, và bịa một cái
         là đặt định danh nội bộ lên màn hình người đã trả tiền.
     3 · `kind` lạ hoặc `section` lạ vẫn phải vẽ, dưới dạng văn xuôi. Bỏ đi là mất chữ khách
         đã mua; ném lỗi là một khối mới làm trắng cả trang.
     4 · Chữ có thể chứa `<b>` và `<i>` — phải để nguyên hai thẻ đó. Thoát hết thì khách đọc
         được `&lt;b&gt;`. Đúng hai thẻ ấy, không hơn: danh sách trắng chặt hơn là tin vào
         kho nội dung.
     5 · Bốn kiểu chở CẤU TRÚC trong một chuỗi ngăn bằng TAB (`meter` `compare_head`
         `compare_row` `pill`) — in thô là tab hiện ra màn hình. `build_variant` thì ngăn
         đoạn bằng dòng trống.
     6 · `door_locked` KHÔNG có `text`. Phải tự vẽ chỗ giữ chỗ, không thì ra một đoạn rỗng.
         `teaser` thì ngược lại: có chữ, cố ý viết dở dang cho bản miễn phí.
     7 · Đọc bậc từ `access`, KHÔNG từ `min_tier` của khối. Máy chủ đã lọc theo bậc trước
         khi mình thấy payload; lọc lần nữa là giấu mất chữ khách đã trả tiền.

     Vì điều 7, bản này bỏ hết phép lọc theo nội dung mà bản 1.x từng phải dựng (ẩn khối có
     `{chỗ trống}`, ẩn dòng mở đầu bằng 🔒, ẩn `cta` khi đã trả tiền, ẩn mấy mục bảng tra).
     Đo trên payload 2.1 thật ngày 31/08: 0 khối còn chỗ trống, 0 khối thiếu `text`, không
     còn mục `b7` chào bán lẫn vào bản đã trả tiền, không còn `NUMWORD`/`ORD`/`BIRTHSTONE`.
     Máy chủ đã dọn ở nguồn, nên chỗ này chỉ còn việc vẽ.
     ───────────────────────────────────────────────────────────────────────── */

  /* Đích của nút chốt: trang bán $29/$199/$179. Chỉ nhận đường dẫn nội bộ — ô này người dựng
     trang gõ tay, gõ nhầm địa chỉ ngoài thì đây thành cửa đẩy khách sang site lạ. */
  function dichOffer() {
    try {
      var g = document.querySelector('[data-plg]');
      var d = g && (g.getAttribute('data-dich-offer') || '').trim();
      if (!d || d.charAt(0) !== '/' || d.charAt(1) === '/') return '';
      return d;
    } catch (e) { return ''; }
  }

  /* Mã biến thể gói $19. Để trống thì mọi chỗ chào hàng vẫn dựng nhưng KHÔNG có nút —
     cùng lối phòng thủ của `dichOffer()`, đừng dẫn khách vào hư không. */
  function bienTheGoiCao() {
    try {
      var g = document.querySelector('[data-plg]');
      var v = g && (g.getAttribute('data-variant-goi-cao') || '').trim();
      return /^\d+$/.test(v) ? v : '';
    } catch (e) { return ''; }
  }

  /* Bậc khách đang có. Đọc từ `access` máy chủ trả — điều 7. Ở đây KHÔNG lọc nội dung,
     chỉ chọn câu chào hàng, nên đọc thêm `min_tier` của khối khoá là hợp lệ. */
  function bac() {
    return (duLieu && duLieu.kq && duLieu.kq.access) || 'free';
  }

  /* Thoát chữ, không chừa thẻ nào. Dùng cho thuộc tính và cho những chỗ nằm trong
     `<span>` / `<h3>` — nơi một thẻ mở lọt vào là vỡ bố cục. */
  function chuGon(t) {
    var d = document.createElement('div');
    d.textContent = t == null ? '' : String(t);
    return d.innerHTML;
  }

  /* Điều 4. Thoát sạch trước, rồi TRẢ LẠI đúng hai thẻ `b` và `i`. Làm ngược lại — dò thẻ
     hợp lệ rồi cho qua — là mở cửa cho mọi thứ khác lọt cùng. */
  function chuInline(t) {
    return chuGon(t)
      .replace(/&lt;(\/?)b&gt;/g, '<$1b>')
      .replace(/&lt;(\/?)i&gt;/g, '<$1i>');
  }

  /* Dòng trống ngăn đoạn. Dùng cho `build_variant` (điều 5) và cho mọi khối văn xuôi. */
  function veDoan(t, lop) {
    var ds = String(t == null ? '' : t).split(/\n{2,}/);
    var ra = '';
    for (var i = 0; i < ds.length; i++) {
      var d = ds[i].trim();
      if (d) ra += '<p class="' + lop + '">' + chuInline(d).replace(/\n/g, '<br>') + '</p>';
    }
    return ra;
  }

  /* Chữ một đoạn: giữ `<b>`/`<i>`, xuống dòng đơn thành `<br>`. Dùng cho phần lá số —
     `signLine`, `houseLine`, dòng năm — vốn cũng là chữ máy chủ viết. */
  function chuAnToan(t) {
    return chuInline(t).replace(/\n/g, '<br>');
  }

  function cot(t) { return String(t == null ? '' : t).split('\t'); }

  /* `labeled`: đậm phần nhãn tới dấu `: ` đầu tiên. Không có dấu ấy thì là đoạn thường. */
  function veNhan(t) {
    var s2 = String(t == null ? '' : t), k = s2.indexOf(': ');
    if (k === -1) return veDoan(s2, 'plg__doan');
    return '<p class="plg__doan"><b class="plg__nhan-in">' + chuInline(s2.slice(0, k + 1)) + '</b> ' +
           chuInline(s2.slice(k + 2)) + '</p>';
  }

  function veMet(t) {
    var c = cot(t), v = parseFloat(c[1]);
    if (!isFinite(v)) v = 0;
    v = Math.max(0, Math.min(100, v));
    return '<div class="plg__met">' +
             '<div class="plg__met-hang"><span>' + chuInline(c[0] || '') + '</span>' +
               '<span class="plg__met-so">' + lam(v) + '</span></div>' +
             '<div class="plg__thanh"><span style="width:' + lam(v) + '%"></span></div>' +
             (c[2] ? '<p class="plg__met-chu">' + chuInline(c[2]) + '</p>' : '') +
           '</div>';
  }

  /* Một khối. KHÔNG nhận `access`: điều 7 — máy chủ đã lọc rồi. */
  function veKhoi(b) {
    var kind = b.kind || 'text';
    var t = b.text;

    switch (kind) {
      case 'section_head':  return '<h2 class="plg__muc">' + chuInline(t) + '</h2>';
      case 'sub_head':      return '<h3 class="plg__muc-con">' + chuInline(t) + '</h3>';
      case 'group_head':    return '<h4 class="plg__muc-nhom">' + chuInline(t) + '</h4>';
      case 'stream_head':   return '<p class="plg__luong">' + chuInline(t) + '</p>';
      case 'labeled':       return veNhan(t);
      case 'meter':         return veMet(t);
      case 'pill':          return '<p class="plg__vien-chip"><span class="plg__chip-nho">' + chuInline(cot(t)[0]) + '</span></p>';
      case 'stone':         return '<blockquote class="plg__da-quy">' + chuInline(t) + '</blockquote>';
      case 'note':          return '<aside class="plg__ghi-chu">' + veDoan(t, 'plg__ghi-chu-d') + '</aside>';
      case 'summary':       return veDoan(t, 'plg__ket');
      case 'door_open':     return veDoan(t, 'plg__doan plg__doan--cua');
      case 'teaser':        return veDoan(t, 'plg__doan plg__doan--he');
      case 'cta':           return veDoan(t, 'plg__cta');
      /* `door_locked` KHÔNG đi qua đây (điều 6 + chuỗi khoá gộp) — xem `veKhoa`. */
      /* Điều 3: `build_variant` và mọi kind chưa biết đều thành văn xuôi. */
      default:              return veDoan(t, 'plg__doan');
    }
  }

  /* CHỮ CLAUDE VIẾT, CHƯA QUA MARKETING — bản chính thức về thì thay ở đây.

     Điều 6: `door_locked` không mang `text`, chỗ giữ chỗ là của mình. Chữ đổi theo BẬC vì
     một câu không đúng cho cả hai bậc: "opens with the full reading" là câu nói với người
     CHƯA trả tiền, mà khách $4.90 đã mua đúng cái "full reading" ấy rồi.

     KHÔNG đếm số trong chữ. Gói bán tên là "5 Solutions", nhưng khách $4.90 đã mở sẵn nghi
     thức 90 giây nên trước mắt họ chỉ còn bốn thân cửa — nói "5" thì sai với người đang
     đọc, nói "4" thì lệch tên gói họ sắp mua. Để tên gói tự làm việc đếm. */
  var KHOA_CHU = {
    chuaTra: 'This passage opens with the full reading.',
    thieuGoiCao: 'This part is in Map & Report + 5 Solutions.',
    nutGoiCao: 'Open it — $19'
  };

  /* Một thẻ cho CẢ CHUỖI khối khoá liền nhau, không phải mỗi khối một thẻ: sau khi tách bậc,
     riêng `report7/v9_doors` có 24 dòng vượt bậc, vẽ rời là 24 ổ khoá giống hệt nhau nối
     đuôi. Gộp lại còn đúng một thẻ cho mỗi thân cửa.

     `coNut` chỉ bật ở thẻ ĐẦU của mỗi tài liệu. Bốn thân cửa khoá là bốn thẻ, mà bốn nút
     "Open it — $19" xếp chồng trong một màn thì đọc ra vừa hối vừa giống lỗi bản mẫu. Một
     nút, ở chỗ khách gặp ổ khoá lần đầu; những thẻ sau vẫn nói cùng một câu để họ biết còn
     gì nữa, chỉ không chào bán lại. */
  function veKhoa(minTier, coNut) {
    var canGoiCao = minTier === 'premium' && bac() !== 'free';
    var bienThe = canGoiCao && coNut ? bienTheGoiCao() : '';
    return '<div class="plg__khoa">' +
             '<span class="plg__khoa-bieu" aria-hidden="true">\u{1F512}</span>' +
             '<p>' + chuGon(canGoiCao ? KHOA_CHU.thieuGoiCao : KHOA_CHU.chuaTra) + '</p>' +
             (bienThe
               ? '<button class="plg__nut plg__khoa-nut" type="button" data-mua-cao>' +
                   chuGon(KHOA_CHU.nutGoiCao) + '</button>'
               : '') +
           '</div>';
  }

  var LIST = { bullet: 'ul', step: 'ol' };

  /* Điều 1 · 2 · 3 gói trong một vòng: đi TUẦN TỰ theo mảng, chỉ gom section để bọc thẻ,
     và gom những khối vốn là một danh sách hay một bảng.

     `bullet` liền nhau là MỘT `<ul>`, `step` liền nhau là MỘT `<ol>` — vẽ rời thành từng
     đoạn là mất hẳn nghĩa danh sách. `compare_head` mở một bảng, các `compare_row` ngay sau
     nó là các hàng; hết chuỗi thì đóng bảng. */
  function veTaiLieu(ds, ten) {
    if (!ds || !ds.length) return '';

    var ra = '', mucTruoc = null, dangMo = null, khoaTruoc = false, daChaoBan = false;

    function dong() {
      if (!dangMo) return '';
      var x = dangMo === 'table' ? '</tbody></table>' : '</' + dangMo + '>';
      dangMo = null;
      return x;
    }

    for (var i = 0; i < ds.length; i++) {
      var b = ds[i], kind = b.kind || 'text', sec = b.section || '';

      if (sec !== mucTruoc) {
        ra += dong() + (mucTruoc === null ? '' : '</div>');
        /* Điều 2: KHÔNG in `sec` ra. Tiêu đề nếu có sẽ tới dưới dạng `section_head`. */
        ra += '<div class="plg__phan" data-muc="' + chuGon(sec) + '">';
        mucTruoc = sec;
        khoaTruoc = false;
      }

      /* Chuỗi `door_locked` liền nhau = MỘT thẻ khoá, cùng cơ chế gom của `bullet` và
         `compare_row` ngay dưới. Khối đầu chuỗi dựng thẻ, những khối sau bị nuốt. */
      if (kind === 'door_locked') {
        if (!khoaTruoc) {
          ra += dong() + veKhoa(b.min_tier, !daChaoBan);
          khoaTruoc = true;
          daChaoBan = true;
        }
        continue;
      }
      khoaTruoc = false;

      if (LIST[kind]) {
        var the = LIST[kind];
        if (dangMo !== the) { ra += dong() + '<' + the + ' class="plg__ds">'; dangMo = the; }
        ra += '<li>' + chuInline(b.text) + '</li>';
        continue;
      }

      if (kind === 'compare_head') {
        var h = cot(b.text);
        ra += dong() + '<div class="plg__bang-boc"><table class="plg__bang"><thead><tr>' +
              '<th>' + chuInline(h[0] || '') + '</th><th>' + chuInline(h[1] || '') + '</th>' +
              '<th>' + chuInline(h[2] || '') + '</th></tr></thead><tbody>';
        dangMo = 'table';
        continue;
      }

      if (kind === 'compare_row') {
        var c = cot(b.text);
        /* Hàng tới mà chưa có đầu bảng (rule bỏ mất `compare_head`): tự mở bảng không đầu,
           còn hơn nhả một chuỗi đầy tab ra trang. */
        if (dangMo !== 'table') { ra += dong() + '<div class="plg__bang-boc"><table class="plg__bang"><tbody>'; dangMo = 'table'; }
        ra += '<tr><th scope="row">' + chuInline(c[0] || '') + '</th>' +
              '<td>' + chuInline(c[1] || '') + '</td><td>' + chuInline(c[2] || '') + '</td></tr>';
        continue;
      }

      ra += dong() + veKhoi(b);
    }

    ra += dong() + (mucTruoc === null ? '' : '</div>');
    return '<section class="plg__tl" data-tl="' + chuGon(ten) + '">' + ra + '</section>';
  }

  /* ─────────────────────────────────────────────────────────────────────────
     LÁ SỐ — vẽ từ `chart` của API, KHÔNG tự tính lại.

     Quiz bê nguyên tự tính lá số ngay trong trình duyệt (`chart7()` trong
     `assets/quiz-inner-weather.js`). Trang này thì không: cùng một người mà hai máy tính
     hai lần thì sớm muộn lệch nhau, và lúc đó không ai biết bên nào đúng. Máy chủ đã trả
     `chart` thì đó là bản chính thức — vẽ đúng thứ nhận được.

     BẪY 1 — `planets` trả về HAI BỘ KHOÁ: cả `Sun` lẫn `sun`, đủ mười cặp. Đọc bừa
     `Object.keys` là vẽ mỗi hành tinh hai lần. Lấy theo danh sách cố định dưới đây.
     BẪY 2 — `aspects` dùng `a`/`b` (viết hoa: `"Sun"`) và `exact`, KHÔNG phải
     `from`/`to`/`orb` như tài liệu ghi. So khoá thì phải hạ chữ thường cả hai bên.
     BẪY 3 — `house`/`houseLine` là null khi khách không nhập giờ sinh
     (`chart.meta.noBirthTime`). Không có giờ thì bỏ hẳn vòng nhà, đừng vẽ vòng rỗng.
     ───────────────────────────────────────────────────────────────────────── */

  var THU_TU_SAO = ['sun', 'moon', 'mercury', 'venus', 'mars',
                    'jupiter', 'saturn', 'uranus', 'neptune', 'pluto'];

  /* `\uFE0E` là dấu ép chữ: thiếu nó thì trình duyệt vẽ mấy ký hiệu này thành EMOJI MÀU
     (ô vuông tím) — đo 31/08 trên Chromium. Có nó thì ra nét chữ, ăn màu theo nguyên tố. */
  var EP_CHU = '\uFE0E';

  var DAU_SAO = {
    sun: '☉', moon: '☽', mercury: '☿', venus: '♀', mars: '♂',
    jupiter: '♃', saturn: '♄', uranus: '♅', neptune: '♆', pluto: '♇'
  };

  var TEN_SAO = {
    sun: 'Sun', moon: 'Moon', mercury: 'Mercury', venus: 'Venus', mars: 'Mars',
    jupiter: 'Jupiter', saturn: 'Saturn', uranus: 'Uranus', neptune: 'Neptune', pluto: 'Pluto'
  };

  var CUNG = ['Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo',
              'Libra', 'Scorpio', 'Sagittarius', 'Capricorn', 'Aquarius', 'Pisces'];

  var DAU_CUNG = ['♈', '♉', '♊', '♋', '♌', '♍',
                  '♎', '♏', '♐', '♑', '♒', '♓'];

  /* Bốn nguyên tố lặp lại đều: lửa · đất · khí · nước, từ Bạch Dương đi tới.
     Tông SÁNG vì trang mặc theme tối của quiz (nền #0e0b1e → #1a1440): bộ màu đậm dùng cho
     nền trắng thì trên nền này gần như biến mất. */
  var MAU_TO = ['#e08a68', '#a9bd7c', '#7fb3e0', '#bfa2f0'];

  var MAU_GOC = {
    trine: '#6fc79b', sextile: '#7fb3e0', square: '#e08a68',
    opposite: '#e0798f', conjunction: '#d4af6a'
  };

  function so(v) { return typeof v === 'number' && isFinite(v); }

  /* Lấy đúng một bộ hành tinh. Ưu tiên khoá chữ thường; bản viết hoa chỉ là bản sao. */
  function locSao(planets) {
    if (!planets) return [];
    var ra = [];
    for (var i = 0; i < THU_TU_SAO.length; i++) {
      var k = THU_TU_SAO[i];
      var p = planets[k] || planets[k.charAt(0).toUpperCase() + k.slice(1)];
      if (p && so(p.lon)) ra.push({ khoa: k, p: p });
    }
    return ra;
  }

  /* Góc trên màn hình: mọc (asc) nằm bên trái, cung chạy ngược chiều kim đồng hồ —
     đúng lối đặt của mọi lá số phương Tây. */
  function gocMH(lon, ascLon) { return (180 + (lon - ascLon)) * Math.PI / 180; }
  function toaDo(lon, ascLon, r) {
    var g = gocMH(lon, ascLon);
    return { x: 200 + r * Math.cos(g), y: 200 - r * Math.sin(g) };
  }
  function lam(n) { return Math.round(n * 100) / 100; }

  function veVongTron(r, lop) {
    return '<circle cx="200" cy="200" r="' + r + '" class="' + lop + '"/>';
  }

  function veBanhXe(c) {
    var ascLon = (c.asc && so(c.asc.lon)) ? c.asc.lon : 0;
    var coNha = !(c.meta && c.meta.noBirthTime);
    var cungMoc = Math.floor(ascLon / 30) % 12;
    /* Khung rộng hơn vòng ngoài 24px mỗi bên: nhãn ASC/MC nằm ở bán kính 205, để khung
       khít 400 thì nhãn bên trái rơi ra x = -5 và bị cắt cụt — đo 31/08. */
    var ra = '<svg class="plg__svg" viewBox="-24 -24 448 448" role="img" ' +
             'aria-label="Your birth chart wheel">';

    ra += veVongTron(192, 'plg__vien') + veVongTron(158, 'plg__vien') +
          veVongTron(coNha ? 126 : 158, 'plg__vien') + veVongTron(96, 'plg__vien-mo');

    /* Mười hai cung: dải màu theo nguyên tố + ký hiệu ở giữa dải. */
    for (var i = 0; i < 12; i++) {
      var d0 = toaDo(i * 30, ascLon, 158), d1 = toaDo(i * 30, ascLon, 192);
      ra += '<line x1="' + lam(d0.x) + '" y1="' + lam(d0.y) + '" x2="' + lam(d1.x) +
            '" y2="' + lam(d1.y) + '" class="plg__vach"/>';
      var g = toaDo(i * 30 + 15, ascLon, 175);
      ra += '<text x="' + lam(g.x) + '" y="' + lam(g.y) + '" class="plg__dau-cung" ' +
            'fill="' + MAU_TO[i % 4] + '">' + DAU_CUNG[i] + EP_CHU + '</text>';
    }

    /* Nhà theo lối nguyên cung: ranh giới nhà trùng ranh giới cung, nên chỉ cần đánh số. */
    if (coNha) {
      for (var h = 0; h < 12; h++) {
        var cn = (cungMoc + h) % 12;
        var t = toaDo(cn * 30 + 15, ascLon, 142);
        ra += '<text x="' + lam(t.x) + '" y="' + lam(t.y) + '" class="plg__so-nha">' +
              (h + 1) + '</text>';
      }
    }

    /* Đường nối các góc chiếu, vẽ TRƯỚC hành tinh để không đè lên ký hiệu. */
    var ds = c.aspects || [];
    var map = {};
    var sao = locSao(c.planets);
    for (var s2 = 0; s2 < sao.length; s2++) map[sao[s2].khoa] = sao[s2].p.lon;
    for (var a = 0; a < ds.length; a++) {
      var g1 = map[String(ds[a].a || '').toLowerCase()];
      var g2 = map[String(ds[a].b || '').toLowerCase()];
      if (!so(g1) || !so(g2)) continue;
      var p1 = toaDo(g1, ascLon, 96), p2 = toaDo(g2, ascLon, 96);
      ra += '<line x1="' + lam(p1.x) + '" y1="' + lam(p1.y) + '" x2="' + lam(p2.x) +
            '" y2="' + lam(p2.y) + '" class="plg__tia" stroke="' +
            (MAU_GOC[ds[a].type] || '#d4af6a') + '"/>';
    }

    /* Hành tinh. Hai cái sát nhau dưới 8 độ thì đẩy ra một vòng khác, không thì chữ chồng. */
    /* Khoảng cách phải tính vòng tròn: 358° và 2° chỉ cách nhau 4°, trừ thẳng ra 356 là
       tưởng xa nhau rồi để hai ký hiệu đè lên nhau ngay ranh Song Ngư — Bạch Dương.
       Và chùm ba (Mặt Trời · Thuỷ · Kim luôn quẩn quanh nhau) cần ba tầng, không phải hai:
       bật tắt 0/1 thì cái thứ ba lại về đúng tầng cái thứ nhất.

       Danh sách này KHÉP KÍN: phần tử cuối cũng là hàng xóm của phần tử đầu. Chỉ so với
       phần tử liền trước là bỏ lọt đúng cặp vắt qua mốc 0° — đo 31/08 với Mặt Trời 358.5°
       và Thuỷ 2.0°: sắp xong thì hai cái nằm ở hai đầu mảng, cùng tầng, cách nhau 7px. */
    var sx = sao.slice().sort(function (m, n) { return m.p.lon - n.p.lon; });

    function xa(a, b) {
      var d = Math.abs(a - b) % 360;
      return d > 180 ? 360 - d : d;
    }

    var tang = [];
    for (var t1 = 0; t1 < sx.length; t1++) {
      tang[t1] = (t1 > 0 && xa(sx[t1].p.lon, sx[t1 - 1].p.lon) < 8)
        ? (tang[t1 - 1] + 1) % 3 : 0;
    }
    /* Khép vòng: cuối đụng đầu thì đẩy cuối sang tầng khác cả hai hàng xóm của nó. */
    var cuoi = sx.length - 1;
    if (cuoi > 0 && xa(sx[cuoi].p.lon, sx[0].p.lon) < 8) {
      while (tang[cuoi] === tang[0] || tang[cuoi] === tang[cuoi - 1]) {
        tang[cuoi] = (tang[cuoi] + 1) % 3;
      }
    }

    for (var k = 0; k < sx.length; k++) {
      var v = toaDo(sx[k].p.lon, ascLon, 112 - tang[k] * 20);
      var vach = toaDo(sx[k].p.lon, ascLon, 96);
      ra += '<line x1="' + lam(v.x) + '" y1="' + lam(v.y) + '" x2="' + lam(vach.x) +
            '" y2="' + lam(vach.y) + '" class="plg__cham"/>' +
            '<text x="' + lam(v.x) + '" y="' + lam(v.y) + '" class="plg__dau-sao">' +
            (DAU_SAO[sx[k].khoa] || '✦') + EP_CHU + '</text>';
    }

    /* Mọc và Thiên đỉnh: hai mốc khách hay hỏi nhất, ghi thẳng lên vành. */
    /* Thiếu `asc` thì neo bánh xe về 0° Bạch Dương (đúng quy ước), nhưng KHÔNG in nhãn
       ASC ở đó — in là bịa ra một mốc mọc không có thật. */
    if (c.asc && so(c.asc.lon)) ra += veMoc(c.asc.lon, ascLon, 'ASC');
    if (c.mc && so(c.mc.lon)) ra += veMoc(c.mc.lon, ascLon, 'MC');

    return ra + '</svg>';
  }

  function veMoc(lon, ascLon, ten) {
    var a = toaDo(lon, ascLon, 158), b = toaDo(lon, ascLon, 196), t = toaDo(lon, ascLon, 205);
    return '<line x1="' + lam(a.x) + '" y1="' + lam(a.y) + '" x2="' + lam(b.x) + '" y2="' +
           lam(b.y) + '" class="plg__moc"/>' +
           '<text x="' + lam(t.x) + '" y="' + lam(t.y) + '" class="plg__ten-moc">' + ten + '</text>';
  }

  /* Thẻ từng hành tinh. `signLine`/`houseLine` là chữ máy chủ viết sẵn — in nguyên,
     không ghép lại, không tự chế câu thay thế khi thiếu. */
  function veTheSao(c) {
    var ds = locSao(c.planets);
    if (c.asc && so(c.asc.lon)) ds.push({ khoa: 'asc', p: c.asc, ten: 'Ascendant', dau: 'ASC' });
    if (c.mc && so(c.mc.lon)) ds.push({ khoa: 'mc', p: c.mc, ten: 'Midheaven', dau: 'MC' });
    if (!ds.length) return '';

    var ra = '<div class="plg__the-sao">';
    for (var i = 0; i < ds.length; i++) {
      var k = ds[i].khoa, p = ds[i].p;
      var cn = CUNG.indexOf(p.sign);
      ra += '<article class="plg__the">' +
              '<div class="plg__the-dau">' +
                '<span class="plg__the-bieu"' +
                  (cn >= 0 ? ' style="color:' + MAU_TO[cn % 4] + '"' : '') + '>' +
                  chuGon((ds[i].dau || DAU_SAO[k] || '✦') + (ds[i].dau ? '' : EP_CHU)) + '</span>' +
                '<h3 class="plg__the-ten">' + chuGon(ds[i].ten || TEN_SAO[k] || k) + '</h3>' +
                '<span class="plg__the-vi">' + chuGon(p.text || ((p.degText || '') + ' ' + (p.sign || ''))) + '</span>' +
              '</div>' +
              (so(p.house) ? '<p class="plg__the-nha">House ' + p.house + '</p>' : '') +
              (p.signLine ? '<p class="plg__the-chu">' + chuAnToan(p.signLine) + '</p>' : '') +
              (p.houseLine ? '<p class="plg__the-chu plg__the-chu--nha">' + chuAnToan(p.houseLine) + '</p>' : '') +
            '</article>';
    }
    return ra + '</div>';
  }

  function veGocChieu(c) {
    var ds = c.aspects || [];
    if (!ds.length) return '';
    /* Khách của trang này là người MỚI tìm hiểu (chân dung trong AGENTS.md: nữ 25–40, Mỹ/Anh,
       92.7% mua cho chính mình). "Sun — Mars · sextile · 2.29°" là mười ba dòng thuật ngữ
       không giải nghĩa, đặt ngay trước phần "nút thắt" vốn chính là bản dịch người-thường của
       chúng. Gấp lại, ai muốn xem thì mở. */
    var ra = '<details class="plg__goc"><summary class="plg__goc-mo">See the technical aspects</summary>' +
             '<ul class="plg__goc-ds">';
    for (var i = 0; i < ds.length; i++) {
      var t = ds[i].type || '';
      ra += '<li class="plg__goc-muc">' +
              '<span class="plg__goc-cham" style="background:' + (MAU_GOC[t] || '#d4af6a') + '"></span>' +
              '<span class="plg__goc-cap">' + chuGon(ds[i].a) + ' — ' + chuGon(ds[i].b) + '</span>' +
              '<span class="plg__goc-loai">' + chuGon(t) + '</span>' +
              (so(ds[i].exact) ? '<span class="plg__goc-do">' + lam(ds[i].exact) + '°</span>' : '') +
            '</li>';
    }
    return ra + '</ul></details>';
  }

  /* Đầu trang: tên, năm cá nhân, và bảy tầng. `tiers` là thang 0–5 (đo 31/08). */
  function veDauTrang(kq) {
    var id = kq.identity || {}, sc = kq.score || {};
    var ra = '<header class="plg__dau">' +
               /* KHÔNG để "Your spirit map" ở đây: đó là tên một trong hai tài liệu, in lên
                  bìa thì màn chọn hoá ra tự mâu thuẫn — nhãn nói bản đồ mà bên dưới lại mời
                  chọn giữa bản đồ và báo cáo. */
               '<p class="plg__nhan">Your reading</p>' +
               (id.name ? '<h1 class="plg__ten">' + chuGon(id.name) + '</h1>' : '') +
               (so(id.personalYear) ? '<p class="plg__phu">Personal year ' + id.personalYear + '</p>' : '');

    var chip = '';
    if (sc.edge) chip += '<span class="plg__chip">Thinnest tier · ' + chuGon(sc.edge) + '</span>';
    if (sc.strength) chip += '<span class="plg__chip">Strongest · ' + chuGon(sc.strength) + '</span>';
    if (sc.band) chip += '<span class="plg__chip">Band · ' + chuGon(sc.band) + '</span>';
    if (chip) ra += '<div class="plg__chips">' + chip + '</div>';

    var t = sc.tiers || [];
    if (t.length) {
      ra += '<ul class="plg__tang">';
      for (var i = 0; i < t.length; i++) {
        var v = so(t[i].value) ? Math.max(0, Math.min(5, t[i].value)) : 0;
        ra += '<li class="plg__tang-muc' + (t[i].key === sc.edge ? ' plg__tang-muc--mong' : '') + '">' +
                '<span class="plg__tang-ten">' + chuGon(t[i].key) + '</span>' +
                '<div class="plg__thanh"><span style="width:' + lam(v / 5 * 100) + '%"></span></div>' +
                '<span class="plg__tang-diem">' + (so(t[i].value) ? lam(v) : '—') + '</span>' +
              '</li>';
      }
      ra += '</ul>';
    }
    return ra + '</header>';
  }

  /* ─────────────────────────────────────────────────────────────────────────
     BA MÀN, ĐÚNG LỐI TRANG KẾT QUẢ CỦA QUIZ

     Quiz không gộp hai tài liệu vào một trang cuộn dài: nó dừng ở màn `hub` (màn 39) cho
     khách CHỌN, rồi mới mở `docMap` hoặc `docReport`. Chữ và bố cục dưới đây bê từ
     `RENDER.hub` trong `assets/quiz-inner-weather.js` — cùng kicker, cùng hai hàng có chấm,
     icon, tên, mô tả và mũi tên. Không nghĩ cách chia mới.

     Bánh xe và thẻ hành tinh nằm trong màn BẢN ĐỒ: chúng đọc từ ngày sinh, đúng thứ mà
     `mapDesc` hứa ("your life map, from your birth date" — dòng phụ K11).

     Chuyển màn KHÔNG đụng vào mảnh neo: mã phiên sống ở đó, ghi đè là mất chìa khoá.
     ───────────────────────────────────────────────────────────────────────── */

  /* Sáu dòng đầu bê từ `RENDER.hub` của quiz. Sáu dòng sau — `bacFull` trở xuống — LÀ CHỮ
     CLAUDE VIẾT, chưa qua marketing; bản chính thức về thì thay đúng ở đây. Chúng có mặt vì
     `kicker` viết cho thời chỉ có một gói: hai tài liệu thì bậc nào cũng có, còn thứ khách
     cần biết là CÁI GÌ đang mở. */
  var CHU = {
    kicker: 'Your two documents',
    sub: 'Two things came out of your answers.',
    mapName: 'Your Spirit Map',
    mapDesc: 'your life map, from your birth date',
    reportName: 'Your Inner Weather Report',
    reportDesc: 'your 7-area report',
    quayLai: 'Both documents',
    bacFull: 'Both documents are open. The 5 Solutions are not yet.',
    bacCao: 'Everything is open — both documents.',
    banName: 'Add the 5 Solutions',
    banDesc: 'What to untangle first, your daily practice rhythm, the kit, and your 7-day map. $19, one payment.',
    sinhName: 'Add your birth date',
    sinhDesc: 'Your Spirit Map is read from it. Type the numbers and the map appears here.',
    sinhThang: 'Month', sinhNgay: 'Day', sinhNam: 'Year',
    sinhNut: 'Open my map',
    sinhSai: 'Please check the date.',
    sinhHong: 'Something went wrong. Please try again.',
    sinhKhongThay: 'We could not find your reading. Reply to your order email and we will sort it out.',
    sinhKetDinh: 'Your date is saved but the map did not build. Reply to your order email and we will finish it for you.',

    /* Thẻ mời góp ý ở cuối hai màn con. CHỮ NÚT không nằm ở đây: nó đọc từ chính nút dính góc
       (`.lg7-neo-chu`), thứ người kinh doanh sửa được trong Theme Customizer — hai lối vào
       cùng một hộp thì phải gọi cùng một tên, không thì khách tưởng là hai thứ khác nhau. */
    gopYDe: 'Did this land?',
    gopYMo: 'Seven quick questions, and only the first one is required. What you say here decides what we write next.',
    gopYNut: 'Tell us how it landed'
  };

  var duLieu = null;

  function veHangThan(icon, ten, mo_ta) {
    return '<span class="plg__hang-cham"></span>' +
           '<span class="plg__hang-ic" aria-hidden="true">' + icon + '</span>' +
           '<span class="plg__hang-than"><b>' + chuGon(ten) + '</b><p>' + chuGon(mo_ta) + '</p></span>' +
           '<span class="plg__hang-mui" aria-hidden="true">›</span>';
  }

  function veHangChon(ma, icon, ten, mo_ta) {
    return '<button class="plg__hang" type="button" data-man="' + ma + '">' +
             veHangThan(icon, ten, mo_ta) +
           '</button>';
  }

  /* Khách đã có lá số thật hay chưa.

     KHÔNG hỏi `chart.planets` bằng truthy. Máy chủ không trả `chart: null` cho phiên thiếu
     ngày sinh — nó chạy qua `buildChart(undefined)` và trả một lá số RỖNG nhưng đủ hình
     dạng: `{ planets: {}, asc: null, aspects: [], ... }`. Trong JS `{}` là truthy, nên phép
     kiểm cũ luôn đúng: form ngày sinh không bao giờ hiện cho BẤT KỲ bậc trả tiền nào, và
     màn Spirit Map vẫn vẽ bánh xe rỗng. Đếm hành tinh mới phân biệt được hai trạng thái. */
  function coLaSo(c) {
    if (!c || !c.planets) return false;
    for (var k in c.planets) { if (Object.prototype.hasOwnProperty.call(c.planets, k)) return true; }
    return false;
  }

  /* Hàng chào gói $19 ở màn chọn. Chỉ hiện cho khách ĐÃ trả tiền mà chưa lên bậc cao —
     khách `free` đã có màn khoá riêng lo việc chào hàng, chồng thêm là bán hai lần một chỗ. */
  function veHangGoiCao() {
    if (bac() !== 'full' || !bienTheGoiCao()) return '';
    return '<button class="plg__hang plg__hang--ban" type="button" data-mua-cao>' +
             veHangThan('🔑', CHU.banName, CHU.banDesc) +
           '</button>';
  }

  /* Hàng bù ngày sinh — một FORM ngay tại chỗ. Khách bấm Skip ở quiz vẫn mua được (chốt
     08/09/2026), nên bản đọc về mà không có lá số là chuyện bình thường — nhưng Bản đồ dựng
     từ lá số, để nguyên thì họ trả tiền cho một nửa trống.

     Bản đầu dẫn sang một trang riêng: trang đọc → trang bù → bấm quay lại → trang đọc, ba
     lần chuyển trang cho việc gõ ba con số (chê 08/09/2026). Nay gõ tại đây, gửi xong tải
     lại bản đọc: hàng này biến mất, hàng "Your Spirit Map" hiện ra, không đổi trang lần nào.
     Ai đã có lá số thì không thấy form — `coLaSo()` ngay dưới. */
  function oSinh(ten, nhan, dai, tuDien) {
    return '<label>' + chuGon(nhan) +
             '<input type="text" inputmode="numeric" maxlength="' + dai + '" autocomplete="' + tuDien + '" data-sinh-' + ten + '>' +
           '</label>';
  }

  /* Lời nhắn cho form ngày sinh phải sống NGOÀI form. Gửi xong là `goi()` tải lại bản đọc và
     `moMan('hub')` vẽ lại toàn bộ khối, nên chữ dán thẳng vào nút cũ biến mất trước khi khách
     kịp đọc. Giữ ở đây, `veHangNgaySinh()` in lại mỗi lần vẽ. */
  var loiSinh = '';

  function veHangNgaySinh() {
    if (bac() === 'free') return '';
    var c = duLieu && duLieu.chart;
    if (coLaSo(c)) return '';
    return '<form class="plg__hang plg__hang--thieu plg__sinh" data-sinh novalidate>' +
             '<span class="plg__hang-cham"></span>' +
             '<span class="plg__hang-ic" aria-hidden="true">⚠️</span>' +
             '<span class="plg__hang-than">' +
               '<b>' + chuGon(CHU.sinhName) + '</b><p>' + chuGon(CHU.sinhDesc) + '</p>' +
               '<div class="plg__sinh-o">' +
                 oSinh('thang', CHU.sinhThang, 2, 'bday-month') +
                 oSinh('ngay', CHU.sinhNgay, 2, 'bday-day') +
                 oSinh('nam', CHU.sinhNam, 4, 'bday-year') +
               '</div>' +
               '<p class="plg__sinh-loi" role="alert" data-sinh-loi' + (loiSinh ? '' : ' hidden') + '>' + chuGon(loiSinh) + '</p>' +
               '<button class="plg__nut plg__sinh-nut" type="submit">' + chuGon(CHU.sinhNut) + '</button>' +
             '</span>' +
           '</form>';
  }

  /* Gửi ngày sinh lên `POST /api/quiz/birth`. Máy chủ ghi ngày, tính lại lá số, và trả 409
     nếu phiên đã có ngày sinh — với khách thì 409 KHÔNG phải lỗi, việc đã xong rồi. Cả hai
     trường hợp đều tải lại bản đọc bằng `goi()`: lá số mới về là màn chọn tự vẽ lại đúng. */
  function guiNgaySinh(form) {
    var ma = layMa();
    if (!ma || !API) return;
    var loi = form.querySelector('[data-sinh-loi]');
    var nut = form.querySelector('button[type="submit"]');
    function bao(chu) { if (loi) { loi.textContent = chu; loi.hidden = !chu; } }
    function so(ten) { var o = form.querySelector('[data-sinh-' + ten + ']'); return o ? o.value.trim() : ''; }
    bao('');
    var mi = Number(so('thang')), di = Number(so('ngay')), yi = Number(so('nam'));
    var namNay = new Date().getFullYear();
    /* Ngày phải CÓ THẬT, không chỉ nằm trong khoảng. `30/02` hay `31/04` lọt qua phép kiểm
       khoảng, mà `DATE_RE` bên máy chủ cũng cho `31` với mọi tháng — và lệnh ghi là MỘT
       CHIỀU: lá số sai thì lần gửi lại nhận 409, khách không sửa được nữa. Cho `Date` tự
       dựng rồi soi lại ba số: tháng tràn sẽ cuộn sang tháng sau và lộ ra ngay. */
    var thu = new Date(yi, mi - 1, di);
    var coThat = thu.getFullYear() === yi && thu.getMonth() === mi - 1 && thu.getDate() === di;
    if (!(mi >= 1 && mi <= 12) || !(di >= 1 && di <= 31) || !(yi >= 1900 && yi <= namNay) || !coThat) {
      bao(CHU.sinhSai);
      return;
    }
    var hai = function (n) { return (n < 10 ? '0' : '') + n; };
    if (nut) { nut.disabled = true; nut.setAttribute('aria-busy', 'true'); }
    fetch(API + '/api/quiz/birth', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: ma, date: yi + '-' + hai(mi) + '-' + hai(di) })
    }).then(function (r) {
      /* 409 nghĩa là phiên ĐÃ có ngày sinh. Với khách đó không phải lỗi — trừ khi lá số vẫn
         rỗng sau khi tải lại, tức máy chủ ghi được ngày mà ghi hụt lá số (`birth.ts` ghi
         session trước, result sau). Vẽ lại đúng cái form vừa bấm mà không nói gì là để khách
         bấm mãi trong im lặng, nên chỗ đó phải nói thẳng là cần người xử lý. */
      if (r.ok || r.status === 409) {
        loiSinh = '';
        goi(function (tai_duoc) {
          if (!tai_duoc) return;
          if (!coLaSo(duLieu && duLieu.chart)) { loiSinh = CHU.sinhKetDinh; moMan('hub'); }
        });
        return;
      }
      bao(r.status === 404 ? CHU.sinhKhongThay : CHU.sinhHong);
      if (nut) { nut.disabled = false; nut.removeAttribute('aria-busy'); }
    })['catch'](function () {
      bao(CHU.sinhHong);
      if (nut) { nut.disabled = false; nut.removeAttribute('aria-busy'); }
    });
  }

  /* Một dòng nói bậc. Khách `free` không cần: màn khoá đã nói thay. */
  function chuBac() {
    var a = bac();
    if (a === 'free') return '';
    var chu = a === 'full' ? CHU.bacFull : CHU.bacCao;
    return '<p class="plg__bac">' + chuGon(chu) + '</p>';
  }

  function veHub() {
    var id = (duLieu && duLieu.kq.identity) || {};
    return veDauTrang(duLieu.kq) +
           '<section class="plg__khoi">' +
             '<p class="plg__kicker">' + chuGon(CHU.kicker) + '</p>' +
             '<h2 class="plg__de-hub">It is written' + (id.name ? ', ' + chuGon(id.name) : '') + '.</h2>' +
             '<p class="plg__sub-hub">' + chuGon(CHU.sub) + '</p>' +
             chuBac() +
             '<div class="plg__hang-ds">' +
               veHangNgaySinh() +
               /* Chưa có lá số thì KHÔNG mời vào màn Bản đồ. Máy chủ bỏ hẳn tài liệu Map khi
                  thiếu ngày sinh (`render-result.ts`: `args.chart ? ... : []`), nên hàng này
                  dẫn tới một màn trống trơn — ngay cạnh cái form dựng ra để cứu họ. */
               (coLaSo(duLieu && duLieu.chart) ? veHangChon('map', '📜', CHU.mapName, CHU.mapDesc) : '') +
               veHangChon('report', '🌦️', CHU.reportName, CHU.reportDesc) +
               veHangGoiCao() +
             '</div>' +
           '</section>';
  }

  /* Mua gói $19 ngay trong trang đọc: thêm hàng rồi vào thẳng checkout.

     Chép lối `muaNgay()` ở `assets/quiz-sang-trang-ban.js`, kể cả THỨ TỰ hai lời gọi —
     `/cart/add.js` TRƯỚC, `/cart/update.js` sau. Đảo lại thì `/cart/update.js` lên khách chưa có
     giỏ sẽ TẠO một giỏ mới (đo 29/09/2026 trên theme nháp), chạy đua với `/cart/add.js` có thể ra
     hai giỏ và hàng nằm ở giỏ mà `/checkout` không mở.

     Mã phiên ghi hai chỗ: thuộc tính cấp đơn cho webhook (Layer 1, nối đơn với phiên) và
     thuộc tính dòng hàng `_quiz_session` cho trang tài khoản (Customer Account API chỉ đọc
     được ở dòng hàng). Không chỗ nào là URL — mã phiên là chìa khoá đọc bản riêng, đưa vào
     địa chỉ là để nó lọt nhật ký truy cập và Referer.

     Cùng lượt `/cart/update.js` còn chở `_ms_cid`/`_ms_sid` của tracker (chỉ khi cookie hợp lệ
     và consent cho phép — hàm `window.__msThuocKhach` của `snippets/brand-ms-gan-khach.liquid`),
     để `order_paid` nối đơn với khách. Lối này gọi `/cart/add.js` trần, không bắn
     `shopify:cart:lines-update`, nên snippet không tự gắn được. Khách chưa có mã phiên quiz vẫn
     gắn `_ms_*`. */
  function muaGoiCao(nut) {
    var bienThe = bienTheGoiCao();
    if (!bienThe) return;
    var ma = layMa();
    var dong = { id: Number(bienThe), quantity: 1 };
    if (ma) dong.properties = { _quiz_session: ma };

    if (nut) { nut.disabled = true; nut.setAttribute('aria-busy', 'true'); }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [dong] })
    }).then(function (res) {
      if (!res.ok) throw new Error('add ' + res.status);
      var thuoc = {}, khach = {};
      if (ma) thuoc.quiz_session = ma;
      try { khach = (typeof window.__msThuocKhach === 'function' && window.__msThuocKhach()) || {}; } catch (e) {}
      if (khach._ms_cid) thuoc._ms_cid = khach._ms_cid;
      if (khach._ms_sid) thuoc._ms_sid = khach._ms_sid;
      if (khach._ms_c) thuoc._ms_c = khach._ms_c;
      if (!thuoc.quiz_session && !thuoc._ms_cid && !thuoc._ms_sid) return null;
      var luotGan = fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: thuoc })
      })['catch'](function () {
        /* Gắn hụt thì đừng chặn đường mua. Mất phần nối đơn với phiên/khách, không mất đơn:
           webhook còn Layer 2/3 khớp theo biến thể và email. */
      });
      /* Trần 2 giây: mạng chập chờn không được giữ khách trước một nút đang `aria-busy`. */
      return Promise.race([luotGan, new Promise(function (ok) { setTimeout(ok, 2000); })]);
    }).then(function () {
      window.location.assign(typeof window.__msGiuUtm === 'function' ? window.__msGiuUtm('/checkout') : '/checkout');
    })['catch'](function () {
      /* Hết hàng, mất mạng, hoặc mã biến thể sai. Trả nút về trạng thái bấm được, đừng để
         khách đứng trước một nút chết. */
      if (nut) { nut.disabled = false; nut.removeAttribute('aria-busy'); }
    });
  }

  /* Khối chốt dẫn sang trang bán. Đích khai ở ô cài đặt; nối thêm trục yếu để trang bên kia
     mở đúng câu chào — `docs/pheu-hanh-trinh-khach.md` khai lối vào là
     `?from=luangiai&axis=<trục>`. Chưa khai đích thì không dựng gì, đừng đẩy khách vào hư không. */
  function veChot() {
    var d = dichOffer();
    if (!d) return '';
    var truc = (duLieu && duLieu.kq.score && duLieu.kq.score.edge) || '';
    if (truc) d += (d.indexOf('?') === -1 ? '?' : '&') + 'axis=' + encodeURIComponent(truc);
    return '<div class="plg__chot">' +
             '<p>Your reading names the thread that frayed first. The 28-day reset is the part that mends it.</p>' +
             '<a class="plg__nut" href="' + chuGon(d) + '">See what comes next</a>' +
           '</div>';
  }

  /* ── Thẻ mời góp ý, cuối hai màn con ─────────────────────────────────────────
     Nút dính góc lo người bỏ giữa chừng. Thẻ này lo người ĐỌC HẾT: xuống tới đáy bản đồ hay
     báo cáo là lúc họ vừa có thứ để nói, và một viên thuốc nhỏ ở góc màn hình thì phần lớn
     khách không bấm.

     Vì sao vẽ ở đây chứ không chèn bằng `pheu-107-feedback.js` như nút cuối màn hub: `moMan()`
     thay sạch `innerHTML` mỗi lần đổi màn, nên thứ chèn từ ngoài vào sống đúng một màn rồi
     biến mất — đó chính là lý do hai màn con xưa nay trống trơn. Vẽ cùng lúc vẽ màn thì
     không có nhịp nhấp nháy nào, và cũng không phải rình DOM.

     Nút KHÔNG mang `data-man`: `moMan()` nghe mọi cú bấm trong khung nội dung qua thuộc tính
     đó, gắn vào là bấm góp ý hoá ra nhảy màn.

     Đặt TRƯỚC `veChot()` là cố ý — hỏi cảm nhận xong mới tới lời mời mua. Ngược lại thì câu
     hỏi thành thứ chắn đường ra, và điểm thu được cũng lệch. */
  function veMoiGopY() {
    var nut = document.querySelector('.lg7-neo-chu');
    var chuNut = (nut && (nut.textContent || '').trim()) || CHU.gopYNut;
    return '<section class="lg7-moi">' +
             '<h2 class="lg7-moi-de">' + chuGon(CHU.gopYDe) + '</h2>' +
             '<p class="lg7-moi-mo">' + chuGon(CHU.gopYMo) + '</p>' +
             '<button class="plg__nut lg7-moi-nut" type="button" data-lg7-mo>' +
               '<span class="lg7-moi-sao" aria-hidden="true">&#9733;</span>' +
               chuGon(chuNut) +
             '</button>' +
           '</section>';
  }

  function veQuayLai() {
    return '<button class="plg__lui" type="button" data-man="hub">‹ ' + chuGon(CHU.quayLai) + '</button>';
  }

  function veManBanDo() {
    var c = duLieu.chart, ra = veQuayLai();
    if (coLaSo(c)) {
      ra += '<section class="plg__khoi plg__khoi--laso">' +
              '<h2 class="plg__khoi-de">' + chuGon(CHU.mapName) + '</h2>' +
              '<p class="plg__sub-hub">' + chuGon(CHU.mapDesc) + '</p>' +
              veBanhXe(c) + veTheSao(c) + veGocChieu(c) +
            '</section>';
    }
    return ra +
           veTaiLieu(duLieu.dsMap, 'map') + veMoiGopY() + veChot();
  }

  function veManBaoCao() {
    return veQuayLai() +
           '<h2 class="plg__khoi-de">' + chuGon(CHU.reportName) + '</h2>' +
           '<p class="plg__sub-hub">' + chuGon(CHU.reportDesc) + '</p>' +
           veTaiLieu(duLieu.dsBC, 'report7') + veMoiGopY() + veChot();
  }

  /* Khách mở BẢN NÀO trong hai bản.

     `gift_opened` chỉ nói khách tới được màn chọn — nó bắn đúng lúc khối nội dung bỏ
     `hidden`, mà lúc đó khách còn chưa bấm gì. Hai tài liệu nằm sau màn ấy, nên thiếu sự
     kiện này thì không có cách nào biết Spirit Map hay Inner Weather Report mới là thứ
     người ta mở, và bao nhiêu người mở cả hai.

     Chỉ đếm `map` và `report`; `hub` không tính — nó còn là đích của lượt vẽ đầu và của
     lượt vẽ lại sau khi gửi ngày sinh.

     Chặn trùng theo TỪNG bản, bằng bộ nhớ PHIÊN, đúng lối `gift_opened`: khách đi tới đi
     lui giữa hai màn là chuyện thường, mỗi lần bấm một dòng thì phép đếm phồng lên. Hôm sau
     quay lại vẫn nên tính là một lượt ghé mới.

     Kèm `access`: bản đọc dựng ra cả khi phiên còn `free`, lúc đó khách mở ra chỉ gặp ổ
     khoá. Đếm "đã đọc thật" thì lọc `mo_khoa = true`, y như bên `gift_opened`. */
  function baoMoTaiLieu(ten) {
    if (ten !== 'map' && ten !== 'report') return;
    if (!window.MS107 || !MS107.bao) return;
    var khoa = 'ms107_doc_' + ten;
    try { if (sessionStorage.getItem(khoa)) return; } catch (e) {}
    try { sessionStorage.setItem(khoa, '1'); } catch (e) {}
    var b = bac();
    MS107.bao('doc_opened', { doc: ten, access: b, mo_khoa: b !== 'free' });
  }

  function moMan(ten) {
    if (!duLieu) return;
    oND.innerHTML = ten === 'map' ? veManBanDo()
                  : ten === 'report' ? veManBaoCao()
                  : veHub();
    oND.setAttribute('data-man', ten);
    window.scrollTo(0, 0);
    baoMoTaiLieu(ten);
  }

  /* Một chỗ nghe cho cả ba màn: nội dung được vẽ lại mỗi lần đổi màn, gắn sự kiện lên từng
     nút thì lần vẽ sau là mất. */
  if (oND) {
    oND.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var mua = e.target.closest('[data-mua-cao]');
      if (mua && oND.contains(mua)) { muaGoiCao(mua); return; }
      /* `nut !== oND` là bắt buộc: `moMan()` đóng dấu `data-man` lên CHÍNH khung nội dung để
         nhớ màn đang mở, nên `closest` leo từ bất kỳ chỗ nào cũng gặp nó. Thiếu vế này thì
         mọi cú bấm trong bài — kể cả nút gửi ngày sinh — đều rơi vào `moMan()`, vẽ lại màn
         đang đứng và cuộn lên đầu; riêng với form thì nút bị xoá giữa cú bấm nên sự kiện
         `submit` không bao giờ nổ và khách bấm mãi không thấy gì. */
      var nut = e.target.closest('[data-man]');
      if (nut && nut !== oND && oND.contains(nut)) moMan(nut.getAttribute('data-man'));
    });
    oND.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('[data-sinh]') : null;
      if (!form || !oND.contains(form)) return;
      e.preventDefault();
      guiNgaySinh(form);
    });
  }

  function hienNoiDung(kq) {
    if (!kq || typeof kq !== 'object') { hien(oLoi); return; }

    /* Máy chủ nói `access` là gì thì theo đúng thế — không tự đoán quyền ở trình duyệt. */
    var daTra = (kq.access || 'free') !== 'free';

    /* Hợp đồng 2.1: bài đọc CHỈ nằm ở `copy.map` / `copy.report7`. Hai khoá cùng tên ở tầng
       ngoài của 1.x đã bị bỏ hẳn — đo trên live 31/08, `map` và `report7` không còn trong
       thân trả về. Đừng dựng lại đường đỡ cho chúng: hai lối lấy một thứ đúng là chỗ bản
       hợp đồng này cố ý dẹp. */
    var co = kq.copy || {};
    var dsMap = co.map;
    var dsBC = co.report7;
    var c = kq.chart;

    /* Đầu trang luôn in được nhãn tĩnh nên không thể lấy chuỗi rỗng làm dấu hiệu hỏng.
       Hỏi thẳng: máy chủ có trả nội dung thật nào không. Không có thì đó là 200 rỗng hoặc
       thân rác — hiện màn lỗi, đừng để khách nhìn một cái tiêu đề lơ lửng. */
    var coND = (dsMap && dsMap.length) || (dsBC && dsBC.length) || coLaSo(c);
    /* `hienNoiDung` còn là đích của vòng hỏi lại bậc, nên một thân rỗng có thể tới TRONG LÚC
       khách đang đọc. Lần đầu thì hiện màn lỗi; đã có bản đọc trên màn rồi thì giữ nguyên,
       đừng lấy mất thứ đang đọc dở vì một câu trả lời hỏng. */
    if (!coND) { if (!duLieu) hien(oLoi); return; }

    duLieu = { kq: kq, dsMap: dsMap, dsBC: dsBC, chart: c, daTra: daTra };
    oND.setAttribute('data-access', kq.access || 'free');
    moMan('hub');
    hien(oND);

    /* `access` KHÔNG chốt tại lúc tải: tiền về qua webhook Shopify sau khi khách đã đứng
       trước trang, nên một phiên có thể nhảy `free` → `full` ngay dưới chân người đọc. Đây
       là đường đi thường gặp nhất của trang này — khách bấm từ trang cảm ơn.

       Hỏi lại mỗi 5 giây, tối đa 12 lần (một phút). Máy chủ cho 30 lượt/phút/IP và trả 429
       sau đó, tài liệu dặn đừng nhanh hơn 3 giây một lần.

       Đổi bậc thì VẼ LẠI TỪ ĐẦU bằng payload mới, không vá payload cũ: bản trả tiền không
       phải bản miễn phí được lấp chỗ trống — `s5` và `s6` là hai chương khác nhau ở hai bậc
       và số khối không khớp nhau. */
    if (!daTra) doiBac();
  }

  var demHoiLai = 0;

  function doiBac() {
    if (demHoiLai >= 12) return;
    demHoiLai++;
    setTimeout(function () {
      var k = layKhoa();
      if (!k) return;
      goiKetQua(k).then(function (res) {
        if (!res.ok) throw new Error('http ' + res.status);
        return res.text().then(function (chu) { return JSON.parse(chu); });
      }).then(function (d) {
        if (d && (d.access || 'free') !== 'free') { hienNoiDung(d); return; }
        doiBac();
      })['catch'](function () {
        /* Hỏi hụt thì thôi, đừng đụng vào thứ khách đang đọc. Vẫn còn nút tải lại. */
        doiBac();
      });
    }, 5000);
  }

  /* Lỗi mang theo MÃ HTTP. Nhánh `catch` phía dưới phải phân biệt 404 — máy chủ nói không có
     bản đọc nào mang khoá này — với mọi hỏng hóc khác (rớt mạng, 429, thân rác). Ném chuỗi
     `'http 404'` thì chỗ bắt phải bóc chữ ra đoán lại; mang thẳng con số theo thì không. */
  function loiHTTP(ma) {
    var e = new Error('http ' + ma);
    e.maHTTP = ma;
    return e;
  }

  /* 404 ở đường ĐỊA CHỈ THƯ không phải hỏng hóc: máy chủ không có bản đọc nào mang địa chỉ đó.
     Màn lỗi chung là ngõ cụt cho đúng ca này — nút "Try again" gọi lại chính địa chỉ vừa hỏng
     nên lại 404, khách bấm mãi không ra gì.

     Ca này gặp nhiều nhất ngay SAU KHI TRẢ TIỀN. Nút ở trang cảm ơn dẫn về một liên kết TRẦN,
     nên trang phải tự lấy địa chỉ trong bộ nhớ trình duyệt (`doc-ban-luan-giai/src/ThankYou.tsx`).
     Bộ nhớ đó trống khi khách mở thư trong ứng dụng thư rồi thanh toán ở trình duyệt khác, và
     giữ địa chỉ KHÁC khi địa chỉ gõ ở checkout không phải địa chỉ đã làm quiz. Cả hai lối đều
     dẫn tới đúng cái 404 này.

     Nên đưa khách về màn nhập địa chỉ, nói thẳng vừa xảy ra chuyện gì, và điền sẵn địa chỉ cũ
     để họ sửa một chữ là xong — thay vì để họ đứng trước một câu xin lỗi không có lối ra. */
  function hienThieuDiaChiSai(dc) {
    hien(oThieu);
    if (!oThuO || !oThuLoi) return;
    try { oThuO.value = dc; } catch (x) {}
    oThuLoi.textContent = 'We could not find a reading for ' + dc +
      '. If you answered the questions with a different address, enter it here.';
    oThuLoi.removeAttribute('hidden');
    try { oThuO.focus(); } catch (x) {}
  }

  function goi(xong) {
    var k = layKhoa();
    if (!k) { hien(oThieu); return; }

    hien(oTai);
    goiKetQua(k).then(function (res) {
      /* 429 là chạm giới hạn gọi. Khách không làm gì được với con số đó nên vẫn gộp về một
         lời nhắn — trừ 404 ở đường địa chỉ thư, ca duy nhất khách TỰ SỬA được (xem dưới). */
      if (!res.ok) throw loiHTTP(res.status);
      /* KHÔNG tin `content-type`. Máy chủ API đang khai `text/html` cho một thân JSON hợp lệ
         (đo 29/08) — tin header thì từ chối đúng bản đọc thật.
         Thân bài mới là bằng chứng: đọc chữ rồi tự phân tích. Không phải JSON thì `JSON.parse`
         ném lỗi, rơi vào nhánh lỗi — vẫn chặn được trang HTML trả về kèm mã 200, mà không
         chặn nhầm response đúng. */
      return res.text().then(function (chu) { return JSON.parse(chu); });
    }).then(function (du_lieu) {
      hienNoiDung(du_lieu);
      if (typeof xong === 'function') xong(true);
    })['catch'](function (e) {
      if (e && e.maHTTP === 404 && k.kieu === 'email') {
        hienThieuDiaChiSai(k.gt);
        if (typeof xong === 'function') xong(false);
        return;
      }
      hien(oLoi);
      /* Báo cho hàm gọi biết lần tải này HỎNG. Nó đọc `duLieu` để quyết định, mà lúc này
         `duLieu` là bản cũ hoặc chưa có gì — không phân biệt thì mọi lần rớt mạng đều bị
         đọc thành "máy chủ ghi hụt lá số", tức nói sai nguyên nhân cho khách. */
      if (typeof xong === 'function') xong(false);
    });
  }

  /* ── Khách tự gõ địa chỉ ở màn thiếu ─────────────────────────────────────────
     Cất vào CẢ hai kho trước khi gọi: bộ nhớ phiên cho lượt này, bộ nhớ lâu dài để lần sau
     quay lại — kể cả sau khi đi vòng qua cổng thanh toán — không phải gõ lại.

     KHÔNG ghi địa chỉ ngược vào URL sau khi gửi. Tài liệu API yêu cầu đúng điều đó, và lý do
     rất cụ thể: ghi vào URL là đưa địa chỉ cho pixel và cho máy chủ đọc. */
  var oThu = goc.querySelector('[data-lg7-thu]');
  if (oThu) {
    var oThuO = oThu.querySelector('[data-lg7-thu-o]');
    var oThuLoi = oThu.querySelector('[data-lg7-thu-loi]');
    oThuO.addEventListener('input', function () { oThuLoi.setAttribute('hidden', ''); });
    oThu.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = (oThuO.value || '').trim().toLowerCase();
      if (!/^[^@\s]+@[^@\s.]+\.[^@\s]+$/.test(v)) {
        oThuLoi.textContent = 'That does not look like an email address.';
        oThuLoi.removeAttribute('hidden');
        try { oThuO.focus(); } catch (x) {}
        return;
      }
      try { sessionStorage.setItem('ms107_email', v); } catch (x) {}
      try { localStorage.setItem('ms107_email', v); } catch (x) {}
      goi();
    });
  }

  if (nutThuLai) nutThuLai.addEventListener('click', goi);
  /* Khách đổi mảnh neo mà không tải lại trang — hiếm, nhưng rẻ để đỡ. */
  window.addEventListener('hashchange', goi);

  goi();
})();
